var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#FA5A7D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 24.625C32.934 24.625 35.3125 22.2465 35.3125 19.3125C35.3125 16.3785 32.934 14 30 14C27.066 14 24.6875 16.3785 24.6875 19.3125C24.6875 22.2465 27.066 24.625 30 24.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9037 25.3447C32.7789 26.0752 31.4382 26.5 30 26.5C28.5618 26.5 27.2211 26.0752 26.0963 25.3447C24.8529 25.8199 23.7 26.521 22.6976 27.4207L30 30.1592L37.3024 27.4207C36.3 26.521 35.1471 25.8199 33.9037 25.3447Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 33.375H40.625C40.1072 33.375 39.6875 33.7947 39.6875 34.3125V36.8125C39.6875 37.3303 40.1072 37.75 40.625 37.75H41.25C42.4581 37.75 43.4375 36.7706 43.4375 35.5625C43.4375 34.3544 42.4581 33.375 41.25 33.375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.466 28.6424C19.2133 28.8175 19.0625 29.1054 19.0625 29.4129V31.5001H19.375C20.9258 31.5001 22.1875 32.7618 22.1875 34.3126V36.8126C22.1875 38.3634 20.9258 39.6251 19.375 39.6251H19.0625V41.6004C19.0625 41.9912 19.3049 42.341 19.6708 42.4782L29.0625 46.0001V31.8101L20.3292 28.5351C20.0412 28.427 19.7187 28.4671 19.466 28.6424Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8125 36.8126V34.3126C37.8125 32.7618 39.0742 31.5001 40.625 31.5001H40.9375V29.4129C40.9375 29.1054 40.7868 28.8175 40.534 28.6424C40.2812 28.4671 39.9586 28.427 39.6708 28.5351L30.9375 31.8101V46.0001L40.3292 42.4782C40.6951 42.341 40.9375 41.9912 40.9375 41.6004V39.6251H40.625C39.0742 39.6251 37.8125 38.3634 37.8125 36.8126Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 36.8125V34.3125C20.3125 33.7947 19.8928 33.375 19.375 33.375H18.75C17.5419 33.375 16.5625 34.3544 16.5625 35.5625C16.5625 36.7706 17.5419 37.75 18.75 37.75H19.375C19.8928 37.75 20.3125 37.3303 20.3125 36.8125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminStudent);
export default __webpack_public_path__ + "static/media/adminStudent.8305c76e6cf723603b1ef94590f588f2.svg";
export { ForwardRef as ReactComponent };